var maxWidthMedia = maxWidth => "@media (max-width: ".concat(maxWidth, "px)");
var minWidthMedia = minWidth => "@media (min-width: ".concat(minWidth, "px)");
export var media = {
  forMobile: maxWidthMedia(1199),
  forDesktop: minWidthMedia(1200),
  forPhoneOnly: maxWidthMedia(599),
  forTabletPortraitAndUp: minWidthMedia(600),
  forTabletLandscapeAndUp: minWidthMedia(900),
  forDesktopAndUp: minWidthMedia(1200),
  forBigDesktopAndUp: minWidthMedia(1800)
};